var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 19,
    viewBox: "0 0 16 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1875 3.0625H12.2695L11.0742 1.09375C10.793 0.636719 10.1602 0.25 9.63281 0.25H6.08203C5.55469 0.25 4.92188 0.636719 4.64062 1.09375L3.44531 3.0625H0.5625C0.246094 3.0625 0 3.34375 0 3.625V4.1875C0 4.50391 0.246094 4.75 0.5625 4.75H1.125L1.86328 16.668C1.89844 17.5469 2.67188 18.25 3.55078 18.25H12.1641C13.043 18.25 13.8164 17.5469 13.8516 16.668L14.625 4.75H15.1875C15.4688 4.75 15.75 4.50391 15.75 4.1875V3.625C15.75 3.34375 15.4688 3.0625 15.1875 3.0625ZM6.08203 1.9375H9.63281L10.3008 3.0625H5.41406L6.08203 1.9375ZM12.1641 16.5625H3.55078L2.8125 4.75H12.9023L12.1641 16.5625Z",
    fill: "#575757"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2d5e1a36af0aa1d15742facf607fb6be.svg";
export { ForwardRef as ReactComponent };